import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Page} from '../../../../../../shared/model/core/page.model';
import {Pageable} from '../../../../../../shared/model/core/pageable.model';
import {AbstractFindManyService} from './abstractFindMany.service';
import {Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';
import {SearchApiModel} from '../../../model/api/searchApi.model';

export abstract class AbstractFindManyPaginatedService<StoredEntity, Entity> extends AbstractFindManyService<StoredEntity, Entity> {

    readonly page$: Observable<Page<Entity>> = new BehaviorSubject(undefined);
    readonly pageable$: Observable<Pageable> = new BehaviorSubject(Pageable.of(0, 20));
    private lastRequest: Subscription;

    protected constructor(service: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>,
                          parameters?: UrlParameter[]) {
        super(service, dataService, parameters);
    }

    getApiModel(): Promise<SearchApiModel> {
        // alert(this.dataService.getEntityUrl());
        return this.dataService.dataService.httpClient.get<SearchApiModel>(this.dataService.dataService.getEntityUrl() + 'api-model/search')
            .toPromise();
    }

    public resolveSortKeyLabel(value: string) {
        return value;
    }

    public get pageable(): Pageable {
        return (this.pageable$ as BehaviorSubject<Pageable>).value;
    }

    public get page(): Page<Entity> {
        return (this.page$ as BehaviorSubject<Page<Entity>>).value;
    }

    public refresh(): Promise<Page<Entity>> {
        const pageable = this.pageable ? this.pageable : Pageable.of(0, 20);
        return this.findPaginated(pageable, this.additionalParameters);
    }

    public nextPage() {
        let pageable;
        if (this.pageable) {
            pageable = Pageable.ofWithSort(this.pageable.pageNumber + 1, this.pageable.pageSize, this.pageable.sort);
        } else {
            pageable = Pageable.of(0, 20);
        }
        this.findPaginated(pageable, this.additionalParameters);
    }

    public changePage(pageNumber: number) {
        let pageable;
        if (this.pageable) {
            pageable = Pageable.ofWithSort(pageNumber, this.pageable.pageSize, this.pageable.sort);
        } else {
            pageable = Pageable.of(pageNumber, 20);
        }
        this.findPaginated(pageable, this.additionalParameters);
    }

    public previousPage() {
        let pageable;
        if (this.pageable?.pageNumber > 0) {
            pageable = Pageable.ofWithSort(this.pageable.pageNumber - 1, this.pageable.pageSize, this.pageable.sort);
        } else {
            pageable = Pageable.of(0, 20);
        }
        this.findPaginated(pageable, this.additionalParameters);
    }

    protected onPageLoaded(page: Page<Entity>) {

    }

    public findPaginated(pageable: Pageable, additionalParameters?: UrlParameter[]): Promise<Page<Entity>> {
        this.setError(undefined);
        this.setLoading(true);
        // this.setPagedIs(undefined);
        this.setPageable(pageable);
        this.additionalParameters = additionalParameters;
        return new Promise<Page<Entity>>((resolve, reject) => {

            if (pageable.sort) {
                this.sort = pageable.sort;
            }

            if (!pageable.sort) {
                pageable.sort = this.sort;
            }
            this.cancel();
            this.lastRequest = this.coreFindPaginatedByDataService(pageable, additionalParameters)
                .subscribe({
                    next: (page) => {
                        (this.page$ as BehaviorSubject<Page<Entity>>).next(page);
                        this.setPageable(pageable);
                        resolve(page);
                    },
                    error: (e) => {
                        this.setError(e);
                        this.setLoading(false);
                        reject(e);
                    },
                    complete: () => {
                        this.setLoading(false);
                    }
                });

        });


    }

    protected setPageable(pageable: Pageable) {
        (this.pageable$ as BehaviorSubject<Pageable>).next(pageable);
    }

    public cancel() {
        this.lastRequest?.unsubscribe();
    }
}
